<template>
  <b-card>
    <form-component :shop="shop" @onSubmit="onSubmit" />
  </b-card>
</template>

<script>
  import FormComponent from '@/components/shops/FormComponent';
import NotificationMixin from '@/mixins/NotificationMixin';
import { create } from '@/http/shops';

export default {
  mixins: [NotificationMixin],
  components: {
    FormComponent,
  },

  data() {
    return {
      shop: {
        name: null,
        county: '',
        category: '',
        address_city: '',
        address_street: '',
        address_number: '',
        address_local_number: '',
        postal_code: '',
        latitude: '',
        longitude: '',
        country: '',
        should_update: false,
        link_1: '',
        is_official: false,
        is_online: false,
      },
    };
  },

  methods: {
    async onSubmit(form) {

      const payload = {
        name: form.name,
        county: form.county,
        category: form.category,
        address_city: form.address_city,
        address_street: form.address_street,
        address_number: form.address_number,
        address_local_number: form.address_local_number,
        postal_code: form.postal_code,
        latitude: form.latitude,
        longitude: form.longitude,
        country: form.country,
        should_update: form.should_update,
        link_1: form.link_1,
        is_official: form.is_official,
        is_online: form.is_online,
      }

      try {
        await create(payload);
        
        this.showSuccessNotification('Dane zapisane', 'Sklep został dodany.');
        this.$router.push({ name: 'shops-index' });
      } catch (error) {
        const message =
          error.response.data.message ??
          'Wystąpił błąd podczas dodawania sklepu. Skontaktuj się ze swoim developerem.';
        this.showErrorNotification('Problem z zapisaniem danych', message);
      }
    },
  },
};
</script>
